












































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {createImage, createSurvey, startSurvey} from '@/app/api/survey.api';
import {CreateSurveyRequest} from '@/app/models/create-survey-request';
import {CreateImageRequest} from '@/app/models/create-image-request';
import QrcodeVue from 'qrcode.vue';
import Header from '@/app/components/Header.vue';
import Footer from '@/app/components/Footer.vue';

interface ImageObject {
    originalFile: File;
    isProcessing: boolean;
    index?: number;
    source?: string;
}

@Component({
    components: {Footer, Header, QrcodeVue},
})
export default class CreateSurveyContainer extends Vue {
    public perspective: string = '';
    public surveyCode: string = '';
    public qrCodeUrl: string = '';
    public isLoading = false;
    public checkBox = false;
    public imageFiles: File[] | null = null;
    public images: ImageObject[] = [];

    get isFormValid(): boolean {
        return !!this.perspective && this.images.filter(image => !image.isProcessing).length > 2 && this.checkBox;
    }

    @Watch('imageFiles')
    public fileInput() {
        if (this.imageFiles) {
            const newImages: ImageObject[] = this.imageFiles
                .map(file => ({
                    originalFile: file,
                    isProcessing: true,
                }));
            this.imageFiles = null;
            this.images = this.images.concat(newImages).map((image, index) => ({
                ...image,
                index,
            }));
            setTimeout(() => {
                this.processNextImage();
            }, 100);
        }
    }

    public async create() {
        this.isLoading = true;
        const createSurveyRequest: CreateSurveyRequest = {
            perspective: this.perspective,
        };
        try {
            const response = await createSurvey(createSurveyRequest);
            this.surveyCode = response.code;
            const href = window.location.href;
            this.qrCodeUrl = href.split('#')[0] + '#/' + this.surveyCode + '/vote';
            await Promise.all(
                this.images.map(async image => {
                    const createImageRequest: CreateImageRequest = {file: image.source as string};
                    await createImage(createImageRequest, response.code);
                }),
            );
            await startSurvey(response.code);
        } finally {
            this.isLoading = false;
        }
    }

    public deleteImage(index: number) {
        this.images.splice(index, 1);
    }

    public back() {
        this.$router.push('/');
    }

    public vote() {
        this.$router.push(this.surveyCode + '/vote');
    }

    private async processNextImage() {
        const newImages = this.images.filter(image => image.isProcessing);
        if (newImages.length > 0) {
            const newImage = newImages[0];
            newImage.source = await this.readImage(newImage.originalFile);
            const imageElement = await this.createImage(newImage.source);
            newImage.source = await this.resizeImage(imageElement);
            this.images[newImage.index as number] = {...newImage, isProcessing: false};
            this.images = [...this.images];

            setTimeout(() => {
                this.processNextImage();
            }, 100);
        }
    }

    private readImage(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    if (event && event.target) {
                        resolve(event.target.result as any);
                    }
                };
                reader.readAsDataURL(file);
            } else {
                alert('Sorry, FileReader API not supported');
                reject();
            }
        });
    }

    private async resizeImage(image: HTMLImageElement) {
        const mainCanvas = document.createElement('canvas');
        const width = 480;
        const height = 480;
        mainCanvas.width = width;
        mainCanvas.height = height;
        const ctx = mainCanvas.getContext('2d');
        if (ctx) {
            let xStart = 0;
            let yStart = 0;
            let newWidth;
            let newHeight;
            let aspectRadio = image.height / image.width;
            if (image.height < image.width) {
                // horizontal
                aspectRadio = image.width / image.height;
                newHeight = height;
                newWidth = aspectRadio * height;
                xStart = -(newWidth - width) / 2;
            } else {
                // vertical
                newWidth = width;
                newHeight = aspectRadio * width;
                yStart = -(newHeight - height) / 2;
            }

            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, 480, 480);
            ctx.drawImage(image, xStart, yStart, newWidth, newHeight);
        }
        return mainCanvas.toDataURL('image/jpeg', 1);
    }

    private createImage(imageSource: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            // tslint:disable-next-line
            img.onload = function() {
                resolve(img);
            };
            img.src = imageSource;
        });
    }

}
